<script setup>
import { getDuration, getDeclOfNum } from '@/utils';
import { Cross, Minus } from '../Icons';
import { Dropdown } from './Index';
import { computed } from 'vue';
import { useApi } from '@/composables/useApi';

const { deleteDraft } = useApi();

const props = defineProps({
	dropdownDate: Object,
});

const emit = defineEmits(['removeDraft', 'setTime']);

const formData = defineModel('formData');
const draft    = defineModel('draft');

const ratingProgress = computed(() =>
	(draft.value.master.average_rating / 5) * 100
);

const reviewsText = computed(() =>
	getDeclOfNum(draft.value.master.reviews_count, [
		'отзыв',
		'отзыва',
		'отзывов',
	]),
);



const imgUrl = img => {
	return `/mediafiles/${img}`
}

const itemImgSrc = item => {
	return item.img ? `/mediafiles/${item.img}` : '/staticfiles/vue/public/profile.png';
};

const removeService = id => {
	const targetService = draft.value.services.find(el => el.id == id);
	const targetId      = draft.value.services.indexOf(targetService);

	draft.value.services.splice(targetId, 1);

	if (!draft.value.services.length)
		removeDraft();
}

const removeDraft = async () => {
	try {
		if (formData.value.pet_id && draft.value.draft_id)
			await deleteDraft(formData.value.pet_id, draft.value.draft_id);
		formData.value.drafts.splice(formData.value.drafts.indexOf(draft.value), 1);

		if (!formData.value.drafts.length)
			delete formData.value.pet_id;

		emit('removeDraft');
	} catch {}
}
</script>

<template>
	<div class="complete-service">
		<div class="complete-service-wr">
			<button @click="removeDraft">
				<Cross />
			</button>
			<div class="complete-service__header">
				<img
					alt=""
					loading="lazy"
					:src="itemImgSrc(draft.master)"
				/>
				<h3>{{ draft.master.fullname }}</h3>
				<div class="master-wr__reviews">
					<span>{{ draft.master.average_rating }}</span>
					<div
						class="master-wr__stars"
						:aria-label="`Рейтинг: ${draft.master.average_rating} из 5`"
					>
						<span
							class="master-wr__progress-bar"
							:style="{width: ratingProgress + '%'}"
						/>
					</div>
					<span>({{ reviewsText }})</span>
				</div>
			</div>
			<div class="complete-service__services">
				<div class="complete-service__service" v-for="service in draft.services">
					<img :src="imgUrl(service.img)" alt="" />
					<h3>{{ service.title }}</h3>
					<div>
						<span class="complete-service__duration">
							{{ getDuration(service.duration) }}
						</span>
						<span class="complete-service__price">
							{{ service.price }}₽
						</span>
					</div>
					<button class="dropdown-content__delete-btn" @click="removeService(service.id)">
						<Minus />
					</button>
				</div>
			</div>
		</div>
		<Dropdown
			v-model="draft"
			:dropdowns="dropdownDate"
			@setTime="emit('setTime')"
		/>
	</div>
</template>

<style lang="scss">
.complete-service {
	display: flex;
	flex-direction: column;
	gap: 20px;
	font-family: 'Raleway';
	font-weight: 500;
}

.complete-service-wr {
	position: relative;	
	padding: 16px;
	background-color: #fff;
	border-radius: 12px;

	& > button {
		position: absolute;
		right: 16px;
	}
}

.complete-service__header,
.complete-service__service {
	position: relative;
	width: fit-content;
	display: grid;
	grid-template-columns: auto 1fr;
	grid-template-rows: repeat(2, auto);
	gap: 4px 14px;
	column-gap: 14px;
	color: #292f3d;

	div span { font-family: 'Inter' }

	h3 {
		font-size: 16px;
		font-family: 'Raleway';
		font-weight: 600;
	}

	img {
		width: 48px;
		height: 48px;
		border-radius: 8px;
		grid-row: 1 / 3
	}
}

.complete-service__services,
.complete-service__service + .complete-service__service { margin-top: 12px }

.complete-service__services { position: relative }

.complete-service__service {
	width: 100%;

	span {
		font-size: 12px;

		& + span { margin-left: 12px }
	}
}

.dropdown-content__delete-btn {
	width: 14px;
	height: 14px;
	position: absolute;
	right: 6px;
	top: 12px;
	display: grid;
	place-items: center;
}
</style>
